<script setup lang="ts">
import {CustomerSummary} from "@/customer/interfaces/Customer";
import {computed} from "vue";
import {Drawer, DrawerClose, DrawerContent, DrawerHeader, DrawerTitle} from "@/core/components/ui/drawer";
import formatHelper from "@/core/helpers/formatHelper";
import {X} from "@lucide/vue";
import CustomerConversationMessagesContent from "@/conversation/components/CustomerConversationMessagesContent.vue";

const open = defineModel<boolean>("open", {default: false});

const props = defineProps<{
    customer?: CustomerSummary;
}>();

const customerName = computed(() => {
    return props.customer?.information?.name ?? 'Patient inconnu';
});
</script>

<template>
  <Drawer v-model:open="open" direction="right">
    <DrawerContent
      class="batch-conversation-drawer inset-y-0 right-0 left-auto mt-0 h-full w-full max-w-2xl rounded-none rounded-l-2xl"
    >
      <DrawerHeader class="shrink-0 border-b border-slate-100 p-4 text-left">
        <div class="flex items-center gap-3">
          <img v-if="customer?.onboarded" alt="Certifié" src="@/assets/icons/certified.svg" class="shrink-0 w-10 object-contain">
          <div class="min-w-0 flex-1">
            <DrawerTitle class="truncate text-base font-semibold">
              {{ customerName }}
            </DrawerTitle>
            <div class="mt-0.5 flex items-center gap-2 text-sm text-muted-foreground">
              <span v-if="customer?.information?.phone" class="truncate">
                {{ formatHelper.readablePhone(customer.information.phone) }}
              </span>
            </div>
          </div>
          <DrawerClose class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-slate-200 text-slate-500 transition-colors hover:bg-slate-100">
            <X class="h-4 w-4" />
          </DrawerClose>
        </div>
      </DrawerHeader>

      <CustomerConversationMessagesContent
        v-if="open && customer"
        :key="customer.id"
        :customer-id="customer.id"
      />
    </DrawerContent>
  </Drawer>
</template>

<style scoped>
.batch-conversation-drawer :deep(> div:first-child) {
  display: none;
}
</style>
